<svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
  <path
    d="M21.0055 9.9992L17.1509 6.1446C15.7755 4.76913 13.9099 3.99649 11.9647 3.9967V3.9967C8.96612 3.99692 6.26968 5.82254 5.15589 8.60662L4.99883 8.99879"
    stroke="#2A3243" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round" />
  <path d="M17.0038 9.9991H21.0055V5.99744" stroke="#2A3243" stroke-width="2.5" stroke-linecap="round"
    stroke-linejoin="round" />
  <path
    d="M2.99797 14.0009L6.85258 17.8555C8.228 19.2309 10.0936 20.0036 12.0387 20.0034V20.0034C15.0373 20.0031 17.7338 18.1775 18.8476 15.3934L19.0046 15.0013"
    stroke="#2A3243" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round" />
  <path d="M6.99963 14.0009H2.99797V18.0025" stroke="#2A3243" stroke-width="2.5" stroke-linecap="round"
    stroke-linejoin="round" />
</svg>
